import { render, staticRenderFns } from "./NeedProposals.vue?vue&type=template&id=08837354&scoped=true&"
import script from "./NeedProposals.vue?vue&type=script&lang=js&"
export * from "./NeedProposals.vue?vue&type=script&lang=js&"
import style0 from "./NeedProposals.vue?vue&type=style&index=0&id=08837354&prod&lang=css&"
import style1 from "./NeedProposals.vue?vue&type=style&index=1&id=08837354&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08837354",
  null
  
)

export default component.exports